import { useIsOwner, useLoggedUser, useLogout } from '@btime/react-session'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { SmallText, Title } from '../../../components/presentation/Text'
import { UserAvatar } from '../../../components/presentation/Avatar'
import { useClearCache } from './_requests/clearCache'
import { useOpenCreateStrongPasswordModal, useOpenUserModal } from '../../../utils/routes/modals/modalsActions'
import FlexGrid from '../../../components/structure/FlexGrid'
import List from '../../../components/list/List'
import SubMenuItem from './_shared/SubMenuItem'

const SubMenu = () => {
  const { t } = useTranslation('menu')
  const logout = useLogout()
  const user = useLoggedUser()
  const isOwner = useIsOwner()
  const openUserModal = useOpenUserModal()
  const openChangePasswordModal = useOpenCreateStrongPasswordModal()
  const [clearCache] = useClearCache()

  return (
    <List minWidth="14rem">
      <SubMenuItem onClick={() => openUserModal(user)}>
        <FlexGrid gutter={0.3} justify="flex-start">
          <UserAvatar user={user} />
          <div>
            <Title size="p" noMargin bold>
              {user.name}
            </Title>
            <SmallText size="xsmall">
              {user.email} (v{process.env.REACT_APP_VERSION})
            </SmallText>
          </div>
        </FlexGrid>
      </SubMenuItem>
      <SubMenuItem icon="RiBuilding4Line" label={t('projects')} path="/home" />
      <SubMenuItem icon="RiTimeLine" label={t('systemLogs')} path="/logs" hide={!isOwner} />
      <SubMenuItem icon="RiTimer2Line" label={t('triggerHistory')} path="/trigger-calls" hide={!isOwner} />
      <SubMenuItem icon="RiDeleteBinLine" label={t('clearCache')} onClick={clearCache} hide={!isOwner} />
      {/* <SubMenuItem icon="RiCurrencyFill" label="Financeiro" path="/finance" hide={!user.canAccessPaymentModule} /> */}
      <SubMenuItem icon="RiLockPasswordLine" label={t('changePassword')} onClick={openChangePasswordModal} />
      <SubMenuItem icon="RiLogoutBoxLine" label={t('logout')} onClick={logout} />
    </List>
  )
}

export default SubMenu
